import { graphql, useStaticQuery } from 'gatsby';
import { SocialNetwork } from '../components/hoc/context/product/configuration-model';
import { NavigationItemProps } from '../components/hoc/components/header/navigation/item';

export type Configuration = {
	socialNetworks: SocialNetwork[];
	headerMenu: NavigationItemProps[];
};

export default function useMenu(): Configuration {
	const { config } = useStaticQuery<{ config: Configuration }>(graphql`
		query menuConfigurationQuery {
			config: menuConfiguration {
				socialNetworks {
					name
					link
				}
				headerMenu {
					link
					label
					target
					title
				}
			}
		}
	`);

	return config;
}
